import { Card } from './Card.js';

export const PreviewPlaceholder = () => (
  <Card>
    <div className="text-center">
      <h1 className="text-xl font-medium text-text">Preview mode</h1>
      <p className="mt-2 text-sm text-text-secondary">
        This page requires a signed-in member to display live data.
      </p>
    </div>
  </Card>
);
